Inputmask.extendDefinitions({
	'B': {
		validator: "[A-Za-z]|[-' ]",
		cardinality: 1,
		prevalidator: null
	},
	'8': {
		validator: "[0-9]|\\*",
		cardinality: 1,
		prevalidator: [{validator: "[0-9]", cardinality: 1}]
	},
	'C': {
		validator: "[A-Za-z0-9]",
		cardinality: 1,
		casing: "upper"
	}
});